import { render, staticRenderFns } from "./location-requester.vue?vue&type=template&id=106033c6&"
import script from "./location-requester.vue?vue&type=script&lang=js&"
export * from "./location-requester.vue?vue&type=script&lang=js&"
import style0 from "./_location-requester.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports